import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, Pill } from "@/components/Bits";

export default function ParentEvents() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then(r => setEvents(r.data)); }, []);
  return (
    <div>
      <PageHeader eyebrow="Upcoming" title="Events at your centre" subtitle="RSVP, consent forms, and event memories." />
      <div className="space-y-3">
        {events.map(e => (
          <div key={e.event_id} className="bg-white rounded-3xl border border-border p-5 flex items-start gap-4" data-testid={`p-event-${e.event_id}`}>
            <div className="w-16 h-16 rounded-2xl bg-mustard-soft text-mustard-hover flex flex-col items-center justify-center font-bold shrink-0">
              <div className="text-3xl leading-none">{new Date(e.event_date).getDate()}</div>
              <div className="text-[10px] uppercase">{new Date(e.event_date).toLocaleString("default", { month: "short" })}</div>
            </div>
            <div className="flex-1">
              <div className="font-heading text-lg font-bold">{e.name}</div>
              <div className="text-sm text-ink-soft mt-1">{e.description}</div>
              <div className="mt-3 flex flex-wrap gap-2">
                {e.consent_required && <Pill tone="terracotta">Consent required</Pill>}
                {e.fee_required && <Pill tone="mustard">Fee ₹{e.fee_amount}</Pill>}
                <button className="px-3 py-1 rounded-full bg-terracotta text-white text-xs font-semibold" data-testid={`rsvp-${e.event_id}`}>RSVP</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
